// src/api/selectionApi.js
import {$authHost, $host} from "./index"; // Импортируем экземпляры axios из главного index.js

export const sendSelectionMail = async (payload) => {
    try {
        const { data } = await $host.post('/api/selection', payload);
        return data;
    } catch (e) {
        throw e;
    }
};

export const createSelection = async (formData) => {
    const { data } = await $authHost.post('api/selection/create', formData);
    return data;
};

export const fetchOneSelection = async (id) => {
    const { data } = await $host.get('api/selection/' + id);
    return data;
};